import { render } from "./ContractDeleted.vue?vue&type=template&id=f0c974bc&scoped=true"
import script from "./ContractDeleted.vue?vue&type=script&lang=js"
export * from "./ContractDeleted.vue?vue&type=script&lang=js"

import "./ContractDeleted.vue?vue&type=style&index=0&id=f0c974bc&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0c974bc"]])

export default __exports__